var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goodsData.bonusText)?_c('div',{class:_vm._.bonus,style:({
    backgroundImage: ("url(" + (require('./images/奖励提示背景.png')) + ")"),
  })},[_c('div',{class:_vm._.text},[_vm._v("单笔最高可获得"+_vm._s(_vm.goodsData.bonusText))]),_c('x-icon',{directives:[{name:"track",rawName:"v-track",value:({
      name: '可获得成长值+黔贝',
      id: '08200191-0af0-4f1f-9c94-d027f634d6cc',
    }),expression:"{\n      name: '可获得成长值+黔贝',\n      id: '08200191-0af0-4f1f-9c94-d027f634d6cc',\n    }"}],class:_vm._.icon,attrs:{"name":"question"},on:{"click":_vm.handleBonusClick}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }